























































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { masterModule } from '@/store/modules/entities/master.module';
import { Competency } from '@/models/competency/competency';
import { SchoolClass } from '@/models/school-class/school-class';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GEnum } from '@/constants/enum.defination';
import { Student } from '@/models/student/student';
import { Activity } from '@/models/activity/activity';
import GJgrowEventCreateExamineeStudentTable from '../ExamineeSetting/GJgrowEventCreateExamineeStudentTable.vue';
import { GPageBase } from '@/mixins';
import GJgrowEventCreateConfirmViewItemCell from '@/views/GJgrowEventCreate/ConfirmView/GJgrowEventCreateConfirmViewItemCell.vue';
import GJgrowEventCreateConfirmViewValueCell from '@/views/GJgrowEventCreate/ConfirmView/GJgrowEventCreateConfirmViewValueCell.vue';
import GJgrowEventCreateConfirmViewCompetency from '@/views/GJgrowEventCreate/ConfirmView/GJgrowEventCreateConfirmViewCompetency.vue';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import { Destination } from '@/models/jgrow/destination';

@Component({
  name: 'GJgrowEventCreateConfirmView',
  components: {
    GJgrowEventCreateConfirmViewCompetency,
    GJgrowEventCreateConfirmViewValueCell,
    GJgrowEventCreateConfirmViewItemCell,
    GJgrowEventCreateExamineeStudentTable,
  },
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateCreateViewSetting extends Mixins(GPageBase) {
  examineeSchoolClassColumns: any[] = []; // 受検対象者(クラス別)設定テーブルのカラム情報
  isEntryLoading: boolean = false; // 生徒個別データローディングフラグ
  lazy: boolean = false;
  viewExamineeStudents: Student[] = []; // 表示用受検者生徒一覧(すでに割り当てられた生徒＋新規に追加した生徒も)
  viewExamineeSchoolClasses: SchoolClass[] = []; // 表示用受検クラス一覧(すでに割り当てられたクラス＋新規に追加した生徒)

  mounted() {
    //確認画面到達フラグON
    jgrowEventCreateModule.setVisitConfirmView(true);
    this.setExamineeSchoolClassColumns();

    if (jgrowEventCreateModule.assignedExamineeStudents.length > 0) {
      // 受検者設定で追加した場合(作成時または更新時)
      this.viewExamineeStudents = jgrowEventCreateModule.plusExamineeStudents.concat(jgrowEventCreateModule.createdEvent.students);
    } else {
      // 受検者設定で追加しなかった場合(更新時のみ)
      this.viewExamineeStudents = this.eventParam.students;
    }

    //新規作成＆コピー時：選択したクラスを反映する
    //編集時：すでに登録されていたクラスを除き、新たに選択したクラスを反映する
    this.eventParam.schoolClasses = schoolClassModule.schoolClassesIncludeSelected.filter((schoolClass: SchoolClass) => {
      if (this.selectedSchoolClassIDs.includes(schoolClass.schoolClassID)) {
        return !schoolClass.selected;
      }
    });

    this.viewExamineeSchoolClasses = schoolClassModule.schoolClassesIncludeSelected.filter((schoolClass: SchoolClass) => {
      return this.selectedSchoolClassIDs.includes(schoolClass.schoolClassID) && !schoolClass.selected;
    });

    const alreadyAssignedSchoolClasses = schoolClassModule.schoolClassesIncludeSelected.filter((schoolClass: SchoolClass) => {
      return this.selectedSchoolClassIDs.includes(schoolClass.schoolClassID) && schoolClass.selected;
    });

    this.viewExamineeSchoolClasses = this.viewExamineeSchoolClasses.concat(...alreadyAssignedSchoolClasses);

    if (jgrowEventCreateModule.jgrowEventPageModeDetail) {
      this.viewExamineeSchoolClasses = schoolClassModule.schoolClasses.filter((sc: SchoolClass) => jgrowEventCreateModule.createdEvent.schoolClassIDs.includes(sc.schoolClassID));
      this.viewExamineeStudents = jgrowEventCreateModule.createdEvent.students;
    }

    this.lazy = true;
  }

  setExamineeSchoolClassColumns() {
    this.examineeSchoolClassColumns = [
      {
        title: '学年',
        key: 'grade',
        width: '100',
        align: 'center',
        render: (h: any, params: any) => {
          const schoolClass: SchoolClass = params.row;
          return h('span', schoolClass.grade + this.$t('YEAR').toString());
        },
      },
      {
        title: 'クラス',
        key: 'schoolClassName',
        width: '705',
        align: 'center',
      },
    ];
  }

  rowClassNameForSchoolClass(row: SchoolClass): string {
    if (row.selected) {
      return 'disable-row';
    }
  }

  setCurrentStep(value: number) {
    jgrowEventCreateModule.setCurrentStep(value);
  }

  get plusExamineeCountWithSuffix(): string {
    if (this.isAssignStudent) {
      return `${jgrowEventCreateModule.plusExamineeStudents.length}名`;
    } else {
      return `${this.eventParam.schoolClasses.length}クラス`;
    }
  }

  get examineeCountWithSuffix(): string {
    if (this.isAssignStudent) {
      return `${this.viewExamineeStudents.length}名`;
    } else {
      return `${this.viewExamineeSchoolClasses.length}クラス`;
    }
  }

  get visitQuestionSettingView(): boolean {
    return jgrowEventCreateModule.visitQuestionSettingView;
  }

  get visitExamineeSettingView(): boolean {
    return jgrowEventCreateModule.visitExamineeSettingView;
  }

  get isAssignStudent(): boolean {
    return jgrowEventCreateModule.isAssignStudent;
  }

  get isAssignSchoolClass(): boolean {
    return jgrowEventCreateModule.isAssignSchoolClass;
  }

  get examineeSelectionTypeString(): string {
    return jgrowEventCreateModule.examineeSelectionTypeString;
  }

  get examineeSelectionType(): GEnum.ExamineeSelectionType {
    return jgrowEventCreateModule.examineeSelectionType;
  }

  get selectedSchoolClassIDs(): number[] {
    return jgrowEventCreateModule.selectedSchoolClassIDs;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get selectedDestinationName(): string {
    const destination = masterModule.destinations.find((dest: Destination) => {
      if (dest.ID === jgrowEventCreateModule.params.destination) return dest;
    });
    return destination ? destination.destinationName : '';
  }

  get selectedActivities(): Activity[] {
    return jgrowEventCreateModule.selectedActivities;
  }

  get questionTypeTitle(): string {
    if (masterModule.allQuestionTypes.length === 0 || this.eventParam.questionSettingType < 0) {
      return '';
    }
    return masterModule.questionTypeByAll(this.eventParam.questionSettingType).title;
  }

  get competencyCognitive(): Competency[] {
    return masterModule.competencyCognitive.map((competency: Competency) => {
      competency.selected = jgrowEventCreateModule.selectionCognitive.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get competencySelf(): Competency[] {
    return masterModule.competencySelf.map((competency: Competency) => {
      competency.selected = jgrowEventCreateModule.selectionSelf.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get competencyGift(): Competency[] {
    return masterModule.competencyGift.map((competency: Competency) => {
      competency.selected = jgrowEventCreateModule.selectionGift.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get competencyCommunity(): Competency[] {
    return masterModule.competencyCommunity.map((competency: Competency) => {
      competency.selected = jgrowEventCreateModule.selectionCommunity.checkAllGroup.includes(competency.competencyID);
      return competency;
    });
  }

  get jgrowEventPageModeEdit(): boolean {
    return jgrowEventCreateModule.mode === GEnum.JgrowEventPageMode.Edit;
  }

  get jgrowEventPageModeCreate(): boolean {
    return jgrowEventCreateModule.mode === GEnum.JgrowEventPageMode.Create;
  }

  get jgrowEventPageModeDetail(): boolean {
    return jgrowEventCreateModule.mode === GEnum.EvalSettingMode.Detail;
  }

  get dispExamTerm(): boolean {
    return this.jgrowEventPageModeCreate || this.jgrowEventPageModeDetail;
  }

  get hasAdditionalQuestion(): boolean {
    return jgrowEventCreateModule.hasAdditionalQuestion;
  }

  get changeExaminee(): boolean {
    return this.viewExamineeSchoolClasses.length > 0 || this.viewExamineeStudents.length > 0;
  }

  // 新規作成実行
  handleEntryEvent() {
    this.lazyAction(() => {
      this.isEntryLoading = true;
      this.eventParam.competencyIDs = jgrowEventCreateModule.selectedCompetencyIDs;
      jgrowEventCreateModule.setIsAutoPageTransition(true);
      jgrowEventCreateModule.setExamineeStudentIDs(jgrowEventCreateModule.plusExamineeStudents.map((student: Student) => student.studentID));
      jgrowEventCreateModule.setExamineeSchoolClassIDs(this.viewExamineeSchoolClasses.map((schoolClass: SchoolClass) => schoolClass.schoolClassID));
      jgrowEventCreateModule.createEvent().then(() => {
        this.isEntryLoading = false;
        this.showNotice(GEnum.MessageType.Success, '登録されました。');

        setTimeout(() => {
          this.$router.replace(`/pages/jgrow/event`);
        }, 2000);
      });
    });
  }

  handleUpdateEvent() {
    this.lazyAction(() => {
      this.isEntryLoading = true;
      this.eventParam.competencyIDs = jgrowEventCreateModule.selectedCompetencyIDs;
      jgrowEventCreateModule.setIsAutoPageTransition(true);
      jgrowEventCreateModule.setExamineeStudentIDs(jgrowEventCreateModule.plusExamineeStudents.map((student: Student) => student.studentID));
      jgrowEventCreateModule.setExamineeSchoolClassIDs(
        this.viewExamineeSchoolClasses
          .filter((schoolClass: SchoolClass) => {
            return !schoolClass.selected;
          })
          .map((schoolClass: SchoolClass) => schoolClass.schoolClassID)
      );
      jgrowEventCreateModule.updateEvent().then(() => {
        this.isEntryLoading = false;
        this.showNotice(GEnum.MessageType.Success, `イベント更新`, `受検コース【${this.eventParam.title}】が更新されました。`, 10);
        setTimeout(() => {
          this.$router.replace(`/pages/jgrow/event`);
        }, 2000);
      });
    });
  }
}
